import React, { Fragment } from 'react';
import { Translate } from 'react-redux-i18n';
import { connect } from 'react-redux';

import BackLink from 'components/back-link';
import Wait from 'components/wait';
import Time from 'components/time';
import { qrDiagnosticsActions } from 'app/actions';
import { OPEN, CLOSED } from 'app/constants';
import QrDiagnostics from 'endpoints/qr-diagnostics';

class Detailed extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { id, getQrDiagnosticsDataByIdThunk } = this.props;

    getQrDiagnosticsDataByIdThunk(id);
  }

  handleDownloadXMLFileClick = () => {
    const { id, downloadQrDiagnosticXMLFileThunk } = this.props;

    downloadQrDiagnosticXMLFileThunk(id);
  };

  handleChangeStatusClick = (status) => {
    QrDiagnostics.updateQrReportStatusById(this.props.id, status).then(response => {
      this.props.history.push('/qr-diagnostics');
    });
  };

  renderIconByStatus = () => {
    const { item } = this.props;

    switch (item.report.status) {
      case OPEN:
        return (
          <button
            style={{ height: 50, padding: '0px 15px' }}
            className="btn btn-secondary"
            onClick={this.handleChangeStatusClick.bind(null, CLOSED)}
          >
            <Translate value="attrs.close" />
          </button>
        );
      case CLOSED:
        return (
          <button
            style={{ height: 50, padding: '0px 15px' }}
            className="btn btn-secondary"
            onClick={this.handleChangeStatusClick.bind(null, OPEN)}
          >
            <Translate value="attrs.restore" />
          </button>
        );
      default:
        return null;
    }
  };

  render() {
    const { isLoading, item, id } = this.props;

    return isLoading || !item ? (
      <Wait />
    ) : (
      <div className="qr-diagnostics">
        <div className="qr-diagnostics_header">
          <div className="d-flex align-items-center">
            <BackLink
              to="/qr-diagnostics"
              className="page-title_back align-self-center"
            />
            <span className="qr-diagnostics_title ml-2">
              <Time value={item.report.registered_on_backend} />
              <span> / </span>
              <span>{item.report.printer_model}</span>
            </span>
          </div>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'max-content max-content',
              gap: '10px',
            }}
          >
            <button
              style={{ height: 50, padding: '0px 65px' }}
              className="btn btn-primary"
              onClick={this.handleDownloadXMLFileClick.bind(null, id)}
              disabled={!item.report.has_bde}
            >
              <Translate value="qr_diagnostics.download_xml" />
            </button>
            {this.renderIconByStatus()}
          </div>
        </div>

        <div className="qr-diagnostics_body">
          {item.table.map((record, index) => (
            <div key={index} className="qr-diagnostics_row">
              <span className="qr-diagnostics_row_title">{record.title}</span>
              <span>{record.value || '-'}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ qrDiagnostics }) => {
  return {
    item: qrDiagnostics.item,
    isLoading: qrDiagnostics.isLoading,
  };
};

export default connect(mapStateToProps, { ...qrDiagnosticsActions })(Detailed);
